import {
  callApiCapNhatThuTu,
  callApiLayCayDonVi,
  callApiLayChiTietDonVi,
  callApiLayDanhSachCanBo,
  callApiLayDanhSachCanBoTrucThuoc,
  callApiLayDanhSachDonViCha,
  callApiUpdateSetLock,
  callApiLayDanhSachDonViPhanTrang,
  callApiLayDanhSachTheoDonViCha,
  callApiSuaDonVi,
  callApiTaoDonVi,
  callApiTaoMoiDonVi,
  callApiThemMoiCanBoTrucThuoc,
  callApiXoaCanBoTrucThuoc,
  callApiXoaDonVi,
  callApiLayDanhSachPhamVi,
  callApiLayThuTuMacDinh
} from "@/api/don-vi";
import {
  TAO_DON_VI_THANH_CONG,
} from "@/constants/message";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layDanhSachDonViCha = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDonViCha(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_DON_VI_CHA", response.data.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const updateSetLock = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateSetLock(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTheoDonViCha = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTheoDonViCha(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_THEO_DON_VI_CHA_THANH_CONG", response.data.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachCanBoTrucThuoc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachCanBoTrucThuoc(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_CAN_BO_TRUC_THUOC", response.data.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachCanBo(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_CAN_BO", response.data.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoMoiDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoMoiDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};
const suaDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const layThuTuMacDinh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayThuTuMacDinh(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error.response.data.message);
        reject(error);
      });
  });
};


const taoMoiCanBoTrucThuoc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiCanBoTrucThuoc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

const xoaCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaCanBoTrucThuoc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

const xoaDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        showMsgError(error.response.data.message);
        resolve(error);
      });
  });
};


const layDanhSachDonViPhanTrang = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachDonViPhanTrang(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_DON_VI_PHAN_TRANG_THANH_CONG", response.data.data);
  }
};

const layCayDonVi = async ({ commit }, payload) => {
  const response = await callApiLayCayDonVi(payload);
  if (response && response.data.succeeded) {
    commit("LAY_CAY_DON_VI_THANH_CONG", response.data.data);
  }
};

// eslint-disable-next-line no-empty-pattern
const layChiTietDonVi = async ({ commit }, payload) => {
  const response = await callApiLayChiTietDonVi(payload.data);
  if (response && response.data.succeeded) {
    commit("LAY_CHI_TIET_DON_VI_THANH_CONG", response.data.data);
    payload.onSuccess(response.data.data);
  }
};

// eslint-disable-next-line no-empty-pattern
const themDonVi = async ({ commit }, payload) => {
  const response = await callApiTaoDonVi(payload.data);
  if (response && response.data.succeeded) {
    showMsgOk(TAO_DON_VI_THANH_CONG);
    commit("THEM_MOI_DON_VI_THANH_CONG", response.data.data);
    payload.onSuccess();
  }
};

// eslint-disable-next-line no-empty-pattern

// eslint-disable-next-line no-empty-pattern


// eslint-disable-next-line no-empty-pattern
const capNhatThuTu = async (context, payload) => {
  const response = await callApiCapNhatThuTu(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess();
  }
};


const layDanhSachPhamVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachPhamVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  updateSetLock,
  layChiTietDonVi,
  layDanhSachDonViCha,
  layDanhSachTheoDonViCha,
  layDanhSachDonViPhanTrang,
  layCayDonVi,
  themDonVi,
  suaDonVi,
  xoaDonVi,
  capNhatThuTu,
  layDanhSachCanBoTrucThuoc,
  taoMoiDonVi,
  layDanhSachCanBo,
  taoMoiCanBoTrucThuoc,
  xoaCanBo,
  layDanhSachPhamVi,
  layThuTuMacDinh
};
